import React from "react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Scale, Flame, Check, Layers } from "lucide-react";

const ACCENTS = {
  live_bilanciato: {
    icon: Scale,
    badge: "Consigliato",
    badgeCls: "bg-amber-400/15 text-amber-300 border border-amber-400/40",
    ring: "ring-amber-400/70",
    iconCls: "text-amber-300 bg-amber-400/10",
  },
  live_conservativo: {
    icon: ShieldCheck,
    badge: "Basso rischio",
    badgeCls: "bg-emerald-500/15 text-emerald-300 border border-emerald-500/30",
    ring: "ring-emerald-400/70",
    iconCls: "text-emerald-300 bg-emerald-500/10",
  },
  live_aggressivo: {
    icon: Flame,
    badge: "Alto rischio",
    badgeCls: "bg-rose-500/15 text-rose-300 border border-rose-500/30",
    ring: "ring-rose-400/70",
    iconCls: "text-rose-300 bg-rose-500/10",
  },
  legacy_recovery: {
    icon: Layers,
    badge: "Legacy",
    badgeCls: "bg-zinc-500/15 text-zinc-300 border border-zinc-500/30",
    ring: "ring-zinc-400/70",
    iconCls: "text-zinc-300 bg-zinc-500/10",
  },
};

export const PresetSelector = ({ presets, activeId, onSelect }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="preset-selector">
      {presets.map((p) => {
        const a = ACCENTS[p.id] || ACCENTS.live_bilanciato;
        const Icon = a.icon;
        const active = activeId === p.id;
        return (
          <button
            key={p.id}
            type="button"
            data-testid={`preset-${p.id}-card`}
            onClick={() => onSelect(p)}
            className={cn(
              "text-left rounded-md border border-border bg-card p-4 shadow-[var(--shadow-sm)] transition-all hover:border-[hsl(var(--primary))]/50 hover:shadow-[var(--shadow-md)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))]",
              active && cn("ring-2", a.ring)
            )}
          >
            <div className="flex items-center justify-between">
              <div className={cn("flex h-8 w-8 items-center justify-center rounded-md", a.iconCls)}>
                <Icon className="h-4 w-4" />
              </div>
              {active ? (
                <span className="flex items-center gap-1 text-xs font-medium text-[hsl(var(--primary))]">
                  <Check className="h-3.5 w-3.5" /> Attivo
                </span>
              ) : (
                <Badge variant="secondary" className={cn("text-[10px] md:text-xs", a.badgeCls)}>
                  {a.badge}
                </Badge>
              )}
            </div>
            <div className="mt-3 font-semibold tracking-[-0.01em] uppercase">{p.name}</div>
            <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{p.description}</p>
            <div className="mt-3 flex flex-wrap gap-2 text-xs text-muted-foreground font-mono">
              <span className="rounded bg-muted px-1.5 py-0.5">Rischio {p.config.riskPerTradePercent}%</span>
              <span className="rounded bg-muted px-1.5 py-0.5">Max DD {p.config.maxTotalDrawdownPercent}%</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};
